var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.activityStatusReady && _vm.isEventEnded)?_c('EventEnd'):(_vm.activityStatusReady)?_c('router-view'):_c('div',{staticClass:"activity-status-message"},[_vm._v(" "+_vm._s(_vm.activityStatusError ? '目前無法取得活動狀態，請稍後重新整理頁面。' : '活動狀態確認中…')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }